import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

export interface SoonLink { to: string; label: string; line?: string }

/**
 * The body of a screen that is designed in Brian's prototype and not built here
 * yet. The screen's own chrome comes from <PageChrome> in the page file; this is
 * only what sits under it. Replace the whole body when the screen is ported.
 */
export function ComingSoon({ title, what, links, children }: {
  title: string
  /** What the screen does, in Brian's words. */
  what: ReactNode
  /** Where the same job can be done today, if anywhere. */
  links?: SoonLink[]
  children?: ReactNode
}) {
  return (
    <div className="gg-soon">
      <span className="eyebrow">Coming in this update</span>
      <h1>{title}</h1>
      <p>{what}</p>
      {children}
      {links && links.length > 0 && (
        <div className="gg-soon__links">
          {links.map((l) => (
            <Link key={l.to + l.label} className="gg-soon__link" to={l.to}>
              <span>{l.label}{l.line && <small>{l.line}</small>}</span>
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6" /></svg>
            </Link>
          ))}
        </div>
      )}
      <div className="gg-soon__note"><b>This screen is being built now.</b> Everything else in the app works today.</div>
    </div>
  )
}
